import React, { useEffect, useState, useContext, useRef } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import { Link } from "react-router-dom";
import "../../../index.css";
import { numberFormat } from "../../../config/numberFormat";
import ToggleSwitch from "../../../_toggleSwitch/toggleSwitch";
import { PostData } from "../../../service/postData";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import QuickAdjustAddNewTerms from "../userExpense/quickAddTerms";
import QuickAddNewParty from "../businessParty/quickPartyAdd";
import QuickAddNewBankDetail from "../cashBank/quickBankAdd";
import QuickAddNewPrefix from "./quickNewPrefixAdd";
import { Loader } from "@progress/kendo-react-indicators";
import TransactionCreateDialog from "../TransactionCreateDialog";
import { useLocation, useHistory } from 'react-router-dom';
import QuickTransactionSaleInvoiceSection from "./QuickTransactionSaleInvoiceSection";

 
const ManageDeliveryChallanCreate = (props) => {
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const auth = queryParams.get('auth');
  const transactionType = queryParams.get('tType') ? queryParams.get('tType') : '';
  const isDuplicate = transactionType == 'DUPLICATE';
  const [businessSetting, setBusinessSetting] = useState({});
  const [searchPartyName, setSearchPartyName] = useState('');
  const [partyId, setPartyId] = useState(0);
  const [partyName, setPartyName] = useState('');
  const [partyContactNo, setPartyContactNo] = useState('');
  const [partyRemainBalance, setPartyRemainBalance] = useState(0);
  const [billingName, setBillingName] = useState('');
  const [billingAddress, setBillingAddress] = useState('');
  const [poNumber, setPoNumber] = useState('');
  const [poDate, setPoDate] = useState(moment().format("YYYY-MM-DD"));
  const [EWayBillNo, setEWayBillNo] = useState('');
  const [paymentTermsData, setPaymentTermsData] = useState([]);
  const [dueOnDate, setDueOnDate] = useState(moment().format("YYYY-MM-DD"));
  const [termsId, setTermsId] = useState(0);
  const [prefixId, setPrefixId] = useState(1);
  const [prefixName, setPrefixName] = useState('');
  const [prefixArray, setPrefixArray] = useState([]);
  const [invoiceNo, setInvoiceNo] = useState(Math.floor(Math.pow(10, 5) + Math.random() * (Math.pow(10, 6) - Math.pow(10, 5) - 1)));
  const [invoiceDate, setInvoiceDate] = useState(moment().format("YYYY-MM-DD"));
  const [invoiceNoChallan, setInvoiceNoChallan] = useState(Math.floor(Math.pow(10, 5) + Math.random() * (Math.pow(10, 6) - Math.pow(10, 5) - 1)));
  const [invoiceDateChallan, setInvoiceDateChallan] = useState(moment().format("YYYY-MM-DD"));
  const [invoiceTime, setInvoiceTime] = useState(moment().format("hh:mm A"));
  const [stateArray, setStateArray] = useState([]);
  const [stateName, setStateName] = useState('');
  const [bankId, setBankId] = useState(-2);
  const [bankName, setBankName] = useState('');
  const [paymentType, setPaymentType] = useState('Cash');
  const [paymentRefNo, setPaymentRefNo] = useState('');
  const [description, setDescription] = useState('');
  const [descImage, setDescImage] = useState('');
  const refDescImage = useRef();
  const [imagePreviewUrl, setImagePreviewUrl] = useState('');
  const [transactionId, setTransactionId] = useState(0);
  const [printType, setPrintType] = useState('showall');
  const [transactionWiseTaxId, setTransactionWiseTaxId] = useState(0);
  const [totalTransTaxRatio, setTotalTransTaxRatio] = useState(0);
  const [totalTransTaxAmount, setTotalTransTaxAmount] = useState(0);
  const [totalTransDiscountAmount, setTotalTransDiscountAmount] = useState(0);
  const [transAdditionalCharge1, setTransAdditionalCharge1] = useState(0);
  const [transAdditionalCharge2, setTransAdditionalCharge2] = useState(0);
  const [transAdditionalCharge3, setTransAdditionalCharge3] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [subTotalAmount, setSubTotalAmount] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(0);
  const [additionalValue1, setAdditionalValue1] = useState('');
  const [additionalValue2, setAdditionalValue2] = useState('');
  const [additionalValue3, setAdditionalValue3] = useState('');
  const [additionalValue4, setAdditionalValue4] = useState(moment().format("YYYY-MM-DD"));
  const [transportDetailField1, setTransportDetailField1] = useState('');
  const [transportDetailField2, setTransportDetailField2] = useState('');
  const [transportDetailField3, setTransportDetailField3] = useState('');
  const [transportDetailField4, setTransportDetailField4] = useState('');
  const [transportDetailField5, setTransportDetailField5] = useState('');
  const [transportDetailField6, setTransportDetailField6] = useState('');
  const [invoiceArray, setInvoiceArray] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState([]);
  const [partyArray, setPartyArray] = useState([]);
  const [bankArray, setBankArray] = useState([]);
  const [companyId, setCompanyId] = useState(0);
  const [businessId, setBusinessId] = useState(0);
  const [signingId, setSigningId] = useState(0);
  const [countryName, setCountryName] = useState('');
  const [showPartyViewList, setShowPartyViewList] = useState(false);
  const [isDialogOpen_Time, setIsDialogOpen_Time] = useState(false);
  const [isDialogOpen_AddPrefix, setIsDialogOpen_AddPrefix] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [message, setMessage] = useState('');
  const [printTypeList, setprintTypeList] = useState([]);
  const [isMakePayment, setIsMakePayment] = useState(false);
  const [isChequeMakePayment, setIsChequeMakePayment] = useState(false);
  const [totalLinkHistoryAmt, setTotalLinkHistoryAmt] = useState(0);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isDialogPreviewImage, setIsDialogPreviewImage] = useState(false);
  const [isDialogAddNewParty, setIsDialogAddNewPArty] = useState(false);
  const [isDialogAddNewBank, setIsDialogAddNewBank] = useState(false);

  const handleKeyPress = (e) => {
    if (!/[0-9.]/.test(e.key)) {
      e.preventDefault();
    }
    const currentValue = e.target.value;
    const dotCount = (currentValue.match(/\./g) || []).length;
    
    if (e.key === '.' && dotCount >= 1) {
      e.preventDefault();
    }
  };
  useEffect(() => {
    let dummyData = [
      { value: "showall", label: "Show All" },
      { value: "Original", label: "Original" },
      { value: "Duplicate", label: "Duplicate" },
      { value: "Triplicate", label: "Triplicate" },
    ]
    setprintTypeList(dummyData);
  }, []);

  useEffect(() => {
    let _UserSession = localStorage.getItem("vs_UserSession");

    // Parse before doing anything else — the previous code read
    // `_UserSession.loginType` off the JSON string (always undefined),
    // then called JSON.parse without a try/catch so a corrupt session
    // string (e.g. "null") would throw and abort the whole effect,
    // leaving the page with no data and no error surfaced.
    if (_UserSession) {
      try {
        _UserSession = JSON.parse(_UserSession);
      } catch (e) {
        _UserSession = null;
      }
    }
    if (_UserSession && _UserSession.loginType != "Admin") {
      {
        let _signingId = _UserSession.loginId;
        let _businessId = _UserSession.tokenKey;
        let _company_id = _UserSession.company_id;
        let _businessSetting = _UserSession.businessSetting || {};

        setSigningId(_signingId);
        setCompanyId(_company_id);
        setBusinessId(_businessId);
        setBusinessSetting(_businessSetting);

        if (_businessSetting.PrintOriginalDuplicate == 0) {
          setPrintType('');
        }
      }
    }
    let _companySession = localStorage.getItem("vs_UserCompanySession");
    if (_companySession) {
      try {
        _companySession = JSON.parse(_companySession);
      } catch (e) {
        _companySession = null;
      }
    }
    if (_companySession) {
      let _businessId = _companySession.business_id;
      let _company_id = _companySession.company_id;
      let _countryCode = _companySession.country_code;
      let _countryName = _companySession.country_name;


      setCompanyId(_company_id);
      setBusinessId(_businessId);
      setCountryName(_countryName);

      getPartyListData(_company_id);
      getStateListData(_countryCode);
      getBankListData(_company_id);
      getTransactionDetails(_company_id, _businessId);
    }


  }, []);

  // The Qty column and the quantity totals read item.newQuantity. An edit-loaded
  // challan may come back without it (older API), which rendered the qty blank and
  // turned totalQuantity into NaN - fall back to the selected serial count, else
  // the item's quantity.
  const withNewQuantity = (invoiceData) => {
    return invoiceData.map((invoice) => ({
      ...invoice,
      items: (invoice.items || []).map((item) => {
        if (parseFloat(item.newQuantity) > 0) {
          return item;
        }
        let serialQty = (item.trackingType == 'Serial' && Array.isArray(item.selectedData))
          ? item.selectedData.filter((data) => data.isSelected === true && data.isFreeQuantity !== true).length
          : 0;
        return ({
          ...item,
          newQuantity: serialQty > 0 ? serialQty : (parseFloat(item.quantity) || 0),
        })
      })
    }));
  }

  const getTransactionDetails = (company_id, businessId) => {
    if (auth) {
      setTransactionId(auth);
      setIsLoading(true);
      setIsEditMode(true);
      const requestData = JSON.stringify({
        transaction_id: auth,
      }); 
      PostData(global.userTransactionDeliveryChallanDetails, requestData, "POST")
        .then((result) => {
          setIsLoading(false);
          let responseJson = result;
          if (responseJson.success) {
            // Any unguarded field access below throws inside this .then and
            // gets swallowed by .catch, leaving state partially populated —
            // subsequent render then hits a stale-state mismatch and blanks
            // the page. Guard the shape defensively so a fresh delivery
            // challan with sparse joined fields still renders.
            let response = (responseJson.response && responseJson.response[0]) || {};
            let totalSummary = response.totalSummary || {};
            let prefix = response.prefix || {};
            let customer = response.customer || {};

            setPartyId(customer.party_id || 0);
            setPartyName(customer.party_name || '');
            setPartyContactNo(customer.party_contact_no || '');
            setBillingName(customer.billing_name || '');
            setBillingAddress(response.billing_address || '');
            setPartyRemainBalance(customer.partyBalance || 0);
            setPoNumber(response.po_number || '');
            setPoDate(response.po_date ? response.po_date : moment().format("YYYY-MM-DD"));
            setDueOnDate(response.dueOnDate ? response.dueOnDate : moment().format("YYYY-MM-DD"));
            setTermsId(response.dueTerms || 0);
            setEWayBillNo(response.E_Way_Bill_No || '');


            setInvoiceNo(response.invoiceNo || '');
            // Empty invoiceDate → moment('').toDate() → Invalid Date, which
            // the DatePicker chokes on. Fall back to today.
            setInvoiceDate(response.invoiceDate ? moment(response.invoiceDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"));
            setInvoiceNoChallan(response.invoiceNoChallan || '');
            setInvoiceDateChallan(response.invoiceDateChallan ? moment(response.invoiceDateChallan).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"));
            setInvoiceTime(response.invoice_time || moment().format("hh:mm A"));
            setStateName(response.countryState || '');
            setTransactionWiseTaxId(response.transactionWiseTaxId || 0);
            setTransAdditionalCharge1(parseFloat(response.TransAdditionalCharge1) || 0);
            setTransAdditionalCharge2(parseFloat(response.TransAdditionalCharge2) || 0);
            setTransAdditionalCharge3(parseFloat(response.TransAdditionalCharge3) || 0);
            setTotalAmount(parseFloat(totalSummary.totalAmount) || 0);
            setSubTotalAmount(parseFloat(totalSummary.subtotal) || 0);
            setTotalTransTaxRatio(totalSummary.gstRatio || 0);
            setTotalTransDiscountAmount(response.totalTransDiscountAmount || 0);
            setTotalTransTaxAmount(parseFloat(totalSummary.gstAmount) || 0);
            setTotalQuantity(totalSummary.totalQty || 0);
            setDueAmount(parseFloat(totalSummary.dueAmount) || 0);
            setAdditionalValue1(response.additional_value_1 || '');
            setAdditionalValue2(response.additional_value_2 || '');
            setAdditionalValue3(response.additional_value_3 || '');
            setAdditionalValue4(response.additional_value_date || moment().format("YYYY-MM-DD"));
            setTransportDetailField1(response.TransportDetailField1 || '');
            setTransportDetailField2(response.TransportDetailField2 || '');
            setTransportDetailField3(response.TransportDetailField3 || '');
            setTransportDetailField4(response.TransportDetailField4 || '');
            setTransportDetailField5(response.TransportDetailField5 || '');
            setTransportDetailField6(response.TransportDetailField6 || '');
            setBankId(response.bankId != null ? response.bankId : -2);
            setBankName(response.bankName || '');
            setPaymentType(response.paymentType || 'Cash');
            setPaymentRefNo(response.paymentRefNo || '');
            setDescription(response.description || '');
            setImagePreviewUrl(response.descImage ? (response.urlImg + response.descImage) : '');
            setPrintType(response.settingType || 'showall');
            setIsMakePayment(!!response.isMakePayment);
            setIsChequeMakePayment(!!response.isChequeMakePayment);
            setTotalLinkHistoryAmt(response.totalLinkHistoryAmt || 0);


            if (customer.party_id) {
              getInvoiceListByParty(customer.party_id, company_id, response);
            }
            getBankListData(company_id);

            getPrefixList(company_id, businessId, prefix);
            setPaidAmount(parseFloat(totalSummary.paidAmount) || 0);
            setSelectedInvoice(Array.isArray(response.invoiceData) ? withNewQuantity(response.invoiceData) : []);

            if (response.isReturn) {
              alert('This transaction cannot be updated because it has a partial or full return. To edit it, delete the return associated with the transaction.');
            } else{
              if(response.isMakePayment){
                alert('This delivery challan cannot be edited because a linked payment exists. Please delete the linked transaction to make changes.');
              } else if(response.isChequeMakePayment){
                alert('This transaction cannot be edited because cheque associated with the transaction is already closed. Re-open the cheque to edit this transaction.');
              }
            }
            
          } else {
            alert("Transaction details not found in system.");
            setTimeout(() => {
              window.location.href = global.webUrl + "business/manage-sale-delivery-challan/";
              return;
            }, Math.floor(Math.random() * 5000) + 1);
            //this.setState({unitArray:_unitArray,isLoaded:true});
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error('userTransactionDeliveryChallanDetails failed:', error && error.message ? error.message : error);
        });

    }else{

      getPrefixList(company_id, businessId);
    }
  }

  const getPartyListData = (_company_id) => {

    let _url_GetData = global.userPartyList + "?company_id=" + _company_id;
    setIsLoading(true);
    PostData(_url_GetData, "", "GET")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {

        } else {
          let _partyBal = 0;
          if (responseJson.response) {
            let _partyArray = responseJson.response;
            setPartyArray(_partyArray);
            _partyArray.map((party, index) => {
              if (party.party_id == partyId) {
                _partyBal = party.totalOutCome;
              }
            });
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  const getInvoiceListByParty = (partyId, company_id, editData) => {
    setIsLoading(true);
    const requestData = JSON.stringify({
      company_id: company_id,
      partyId: partyId,
      type: "SALE",
    });

    PostData(global.getPartyOldTransationData, requestData, "POST")
      .then((result) => {
        if (result.success == false) {
          if(!editData){
            setInvoiceArray([]);
            setSelectedInvoice([]);
            alert('No invoice available.');
          }else {
            let dataInvoice = withNewQuantity(editData.invoiceData).map((item) => {
              let items = item.items.map((data) => ({...data, isSelect: true}));

              return({
                ...item,
                isSelect: items.length > 0,
                items: [...items]
              })
            });
            setInvoiceArray(dataInvoice);
            setSelectedInvoice(dataInvoice);
          }
        } else {

          let data = result.response.map((item) => ({
            ...item,
            isSelect: false
          }))

          setInvoiceArray(data);
        }
        setIsLoading(false);
      })
      .catch((error) => setIsLoading(false));
  }

  
  const getPrefixList = (_company_id, _businessId, prefix) => {
    let dummyData = [{ "isSelected": false, "prefix_id": -1, "prefix": "Add Prefix", "prefix_type": "DELIVERY CHALLAN" },
      { "isSelected": false, "prefix_id": 0, "prefix": "None", "prefix_type": "DELIVERY CHALLAN" }];
    const requestData = JSON.stringify({
      company_id: _company_id,
      businessId: _businessId,
      type: "DELIVERY CHALLAN",
    });
    PostData(global.businessWebPrefixList, requestData, "POST")
      .then(async (result) => {
        let responseJson = result;
        if (responseJson.success == false) {
          setPrefixArray([...dummyData]);
          setPrefixId(0);
          setPrefixName('None');
        } else {
          if (responseJson.response) {
            let _prefixArray = responseJson.response;
            _prefixArray = _prefixArray.filter(
              (itemData) => itemData.prefix != null
            );
            
            if(prefix && prefix.id){
              const prefixData = _prefixArray.filter((data) => data.prefix_id == prefix.id)
              if(prefixData.length > 0){
                setPrefixId(prefixData[0].prefix_id);
                setPrefixName(prefixData[0].prefix);
              }else{
                setPrefixId(0);
                setPrefixName('None');
              }
              
            }else{
              let _prefixSelData = _prefixArray.filter((item) => item.isSelected == true)
              let id = 0;
              let name = 'None';
              
              if(_prefixSelData.length === 0){
                dummyData = dummyData.map((data) => ({
                  ...data,
                  isSelected: data.prefix_id == 0
                }))
              }else{
                id = _prefixSelData[0].prefix_id;
                name = _prefixSelData[0].prefix;
              }
              setPrefixId(id);
              setPrefixName(name);
            }
            setPrefixArray([...dummyData, ..._prefixArray])
          }
        }
      })
      .catch((error) => {
        console.log('error', error);
       });
  }
  const getStateListData = (countryCode) => {
    let _url_GetData =
      global.adminStateList + "?countryCode=" + countryCode;
    PostData(_url_GetData, "", "GET")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {
        } else {
          if (responseJson.response) {
            let _stateArray = responseJson.response;
            setStateArray(_stateArray);
          }
        }
      })
      .catch((error) => { });
  }
  const getBankListData = (company_id) => {
    let dummyData = [{ id: "-1", bank_name: "Add Bank", paymentType: "" },
    { id: "-2", bank_name: "Cash", paymentType: "Cash" },
    { id: "-3", bank_name: "Cheque", paymentType: "Cheque" }]
    let _url_GetData = global.userBankDetailsList + "?company_id=" + company_id;
    PostData(_url_GetData, "", "GET")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {
          setBankArray([...dummyData]);
        } else {
          if (responseJson.response) {
            let _bankDetailArray = responseJson.response;
            setBankArray([...dummyData, ..._bankDetailArray]);
          }
        }
      })
      .catch((error) => { });
  }

 
  const getColorBal = () => {
    let _colorBal = "text-normal";
    if (partyRemainBalance < 0) {
      _colorBal = "text-danger";
    } else if (partyRemainBalance > 0) {
      _colorBal = "text-success";
    } else {
      _colorBal = "text-normal";
    }
    return _colorBal;
  }
  const onChangePartyName = (value) => {
    setSearchPartyName(value);
    setPartyId(0);
    setPartyName('');
  }
  const manageShowPartyFilter = () => {
    setPartyId(0);
    setPartyName('');
    setShowPartyViewList(true);
  }


  const viewPartyList = () => {
    let _colorVal = '';
    let data = partyArray.filter((data) => data.party_name.toLowerCase().includes(searchPartyName.toLowerCase())).map((party, i) => {
      let _balance = party.totalOutCome;
      if (_balance < 0) {
        _colorVal = "red";
      } else if (_balance == 0 || _balance == "0") {
        _colorVal = "black";
      } else {
        _colorVal = "green";
      }
      return (
        <li
          key={i}
          className="iti__party iti__standard"
          id="iti-item-in"
          onClick={() => selectPartiess(party)}
        >
          <span className="iti__party-name">{party.party_name}</span>
          <span className="iti__party-balance" style={{ color: _colorVal }}>
            {numberFormat(Math.abs(_balance))}
          </span>
        </li>
      );
    });
    return data;
  }
  const selectPartiess = (party) => {
    setSearchPartyName('');
    setPartyId(party.party_id);
    setPartyName(party.party_name);
    setPartyRemainBalance(party.totalOutCome);
    setPartyContactNo(party.party_contact_no);
    setBillingName(party.billing_name);
    setBillingAddress(party.party_billing_address);
    setStateName(party.countryState);
    setShowPartyViewList(false);
    getInvoiceListByParty(party.party_id, companyId);
  }

  const selectPrefix = (e) => {
    let value = e.target.value;
    if (value == -1) {
      setIsDialogOpen_AddPrefix(true);
    } else {
      let prefixData = prefixArray.filter((data) => data.prefix_id == value)[0];
      setPrefixId(prefixData.prefix_id);
      setPrefixName(prefixData.prefix);
    }
  }
  const handleCallBackInvoiceDate = (date) => {
    date = moment(date).format("YYYY-MM-DD")
    setInvoiceDateChallan(date);
    if (termsId > 0) {
      let patmentData = paymentTermsData.filter((data) => data.id == termsId)[0];
      let newDueDate = moment(date).add(patmentData.terms_days, "days").format("YYYY-MM-DD");
      setDueOnDate(newDueDate);
    }
  };
  const viewInvoiceDate = () => {
    const slectedDate = moment(invoiceDateChallan).toDate();
    return (
      <DatePicker
        selected={slectedDate}
        disabled={isDuplicate}
        className="form-control search-box"
        onChange={date => handleCallBackInvoiceDate(date)}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />
    );
  }
  const handleCallBackAdditionalValue4Date = (date) => {
    setAdditionalValue4(moment(date).format("YYYY-MM-DD"));
  };
  const viewAdditionalDate = () => {
    const slectedDate = moment(additionalValue4).toDate();
    return (
      <DatePicker
        selected={slectedDate}
        disabled={isDuplicate}
        className="form-control search-box"
        onChange={date => handleCallBackAdditionalValue4Date(date)}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />
    );
  }
  const onMouseLeaveHandlerTime = () => {
    setIsDialogOpen_Time(false)
  }
  const onMouseLeaveHandler = () => {

  }
  const manageShowTimeFilter = () => {

  }
  const generateTimeSlots = (interval = 1) => {
    const slots = [];
    const start = new Date(); // Start from current time
    start.setSeconds(0, 0); // Round down to the nearest hour

    for (let i = 0; i < 24 * 60 / interval; i++) {
      start.setMinutes(start.getMinutes() + interval);
      //slots.push(formatTime(new Date(start)));
      slots.push(moment(start).format("hh:mm A"));
    }

    return slots;
  };
  const availableTimeSlots = generateTimeSlots();
  const getTimeSlotList = () => {
    return availableTimeSlots.map((time, index) => (
      <div
        key={index}
        className="dropdown-item"
        onClick={() => {
          setIsDialogOpen_Time(false);
          setInvoiceTime(time);
        }}
      >
        {time}
      </div>
    ))
  }

  const selectBank = (e) => {
    let value = e.target.value;
    if (value == -1) {
      setIsDialogAddNewBank(true);
    } else {
      let bankData = bankArray.filter((data) => data.id == value)[0];
      setBankId(value);
      setBankName(bankData.bank_name ? bankData.bank_name : bankData.display_name);
      setPaymentType(bankData.paymentType);
    }
  }
  const onChangeFileUploadHandler = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      const validImageTypes = ['image/jpeg', 'image/png'];
        if (validImageTypes.includes(file.type)) {
          setDescImage(file);
          setImagePreviewUrl(reader.result);
        }else{
          e.target.value = '';
          alert('Please select a valid image file (JPEG, PNG, GIF).');
          return
        }
    };
    reader.readAsDataURL(file);
  }
  
  const previewImagesListing = () => {
    let dataList = [];
    let _imageDetails = imagePreviewUrl;
    if (_imageDetails != "") {
      dataList.push(
        <>
        <img
          style={{ width: "50px", height: '50px' }}
          className="preview"
          src={_imageDetails}
          alt={"image-"}
          key="13213"
        />
        <button
        style={{marginLeft: 10}}
            className="btn btn-info"
            onClick={() => {
              setIsDialogPreviewImage(true);
            }}
        >
            <i className="fa fa-eye" title="Preview"></i>
        </button>
        <button
        style={{marginLeft: 10}}
            className="btn btn-info"
            onClick={() => {
              refDescImage.current.value = '';
              setDescImage('');
              setImagePreviewUrl('');
            }}
        >
            <i className="fa fa-trash" title="Delete"></i>
        </button>
        </>
      );
    }
    return dataList;
  }
  const roundToDecimalPlaces = (value) => {
    value = parseFloat(value);
    value = isNaN(value) ? 0 : parseFloat(value.toFixed(2));
    return value;
  };

  const onCallbackAddPrefix = (id, name) => {
    setIsDialogOpen_AddPrefix(false);
    setPrefixId(id);
    setPrefixName(name);
    getPrefixList(companyId, businessId);
  }

  
  const onChangeAdditionalCharge1 = (value) => {
    value = value * 1;
    setTransAdditionalCharge1(value);
    let _totalAmount = subTotalAmount;
    _totalAmount = _totalAmount + totalTransTaxAmount + value + transAdditionalCharge2 + transAdditionalCharge3;
    console.log('_totalAmount', _totalAmount)
    setTotalAmount(roundToDecimalPlaces(_totalAmount));
    _totalAmount = _totalAmount - paidAmount;
    setDueAmount(roundToDecimalPlaces(_totalAmount));
  }
  const onChangeAdditionalCharge2 = (value) => {
    value = value * 1;
    setTransAdditionalCharge2(value);
    let _totalAmount = subTotalAmount;
    _totalAmount = _totalAmount + totalTransTaxAmount + transAdditionalCharge1 + value + transAdditionalCharge3;
    setTotalAmount(roundToDecimalPlaces(_totalAmount));
    _totalAmount = _totalAmount - paidAmount;
    setDueAmount(roundToDecimalPlaces(_totalAmount));
  }
  const onChangeAdditionalCharge3 = (value) => {
    value = value * 1;
    setTransAdditionalCharge3(value);
    let _totalAmount = subTotalAmount;
    _totalAmount = _totalAmount + totalTransTaxAmount + transAdditionalCharge1 + transAdditionalCharge2 + value;
    setTotalAmount(roundToDecimalPlaces(_totalAmount));
    _totalAmount = _totalAmount - paidAmount;
    setDueAmount(roundToDecimalPlaces(_totalAmount));
  }
  const onChangePaidAmount = (value) => {
    let newValue = value;
    newValue = newValue.replace(/[^0-9.-]/g, '');

    if ((newValue.match(/\./g) || []).length > 1) {
      newValue = newValue.slice(0, -1);
    }
    if(newValue > totalAmount){
      return;
    }
    setPaidAmount(newValue);
    let _totalAmount = totalAmount - newValue;
    setDueAmount(roundToDecimalPlaces(_totalAmount));
  }
  const callBack = async (invoice, subTotalAmount) => {
    setSubTotalAmount(subTotalAmount);
    let totalQuantity = 0;
    let totalAllQuantity = 0;
    let paidAmount = 0;
    let totalTransTaxRatio = 0;
    let transactionWiseTaxId = 0;
    let totalTransDiscountAmount = 0;
    let totalItemTaxAmount = 0;
    let totalItemTaxRatio = 0;
    let items = [];
    let allItems = [];
    let _transAdditionalCharge1 = 0;
    let _transAdditionalCharge2 = 0;
    let _transAdditionalCharge3 = 0;

    let invoiceNo = '';
    let invoiceDate = '';

    let _invoice = invoice.map((data) => {
      let SelectedQty = 0;
      let qty = 0;
      data.items.filter((data) => data.isSelect).map((item) => {
        SelectedQty += item.newQuantity ? parseInt(item.newQuantity) : 0
      });
      data.items.map((item) => {
        qty += item.quantity ? parseInt(item.quantity) : 0
      });
      let totalSummary = {...data.totalSummary};
      totalSummary.subtotal = subTotalAmount;
      totalSummary.totalSelectedInvQty = SelectedQty;
      totalSummary.totalQty = qty;
      
      let innerItem = data.items.filter((data) => data.isSelect);
      let innerAllItem = data.items;
      items = [...items, ...innerItem];
      allItems = [...allItems, ...innerAllItem];

      totalTransTaxRatio += parseFloat(totalSummary.gstRatio);
      paidAmount += parseFloat(totalSummary.paidAmount);
      totalTransDiscountAmount += parseFloat(totalSummary.totalDiscount);
      
      _transAdditionalCharge1 += data.TransAdditionalCharge1 ? parseFloat(data.TransAdditionalCharge1) : parseFloat(transAdditionalCharge1);
      _transAdditionalCharge2 += data.TransAdditionalCharge2 ? parseFloat(data.TransAdditionalCharge2) : parseFloat(transAdditionalCharge2);
      _transAdditionalCharge3 += data.TransAdditionalCharge3 ? parseFloat(data.TransAdditionalCharge3) : parseFloat(transAdditionalCharge3);

      invoiceNo = data.invoiceNo;
      invoiceDate = data.invoiceDate;
      return({
        ...data,
        totalSummary: totalSummary
      })
    });

    allItems.map((item) => {
      totalAllQuantity += parseFloat(item.newQuantity);
    });
    items.map((item) => {
      //subtotal += parseFloat(item.total_amount);
      totalQuantity += parseFloat(item.newQuantity);
      totalItemTaxRatio += item.tax_type.ratio ? item.tax_type.ratio : 0;
      totalItemTaxAmount += parseFloat(item.tax_value);
    });
    // Edit-loaded invoiceData carries no invoiceNo/invoiceDate (only invoice_no), so
    // overwriting here saved the linked invoice as "undefined" - keep the value
    // getTransactionDetails set from response.invoiceNo/invoiceDate instead.
    if (invoiceNo) {
      setInvoiceNo(invoiceNo);
    }
    if (invoiceDate) {
      setInvoiceDate(invoiceDate);
    }
    setSelectedInvoice(_invoice);
    setTotalQuantity(totalQuantity);
    setTransactionWiseTaxId(transactionWiseTaxId);
    setTransAdditionalCharge1(_transAdditionalCharge1);
    setTransAdditionalCharge2(_transAdditionalCharge2);
    setTransAdditionalCharge3(_transAdditionalCharge3);
    subTotalAmount = subTotalAmount - totalTransDiscountAmount;
    let _taxAmount = (totalTransTaxRatio / 100) * subTotalAmount;
    _taxAmount = roundToDecimalPlaces(_taxAmount);
    let totalAmount = subTotalAmount + (_taxAmount + _transAdditionalCharge1 + _transAdditionalCharge2 + _transAdditionalCharge3);

    setTotalTransTaxRatio(totalTransTaxRatio);
    setTotalTransTaxAmount(_taxAmount);
    setTotalTransDiscountAmount(totalTransDiscountAmount);
    setTotalAmount(roundToDecimalPlaces(totalAmount));
    let _paidAmount = paidAmount;
    setPaidAmount(_paidAmount);
    totalAmount = totalAmount - _paidAmount;
    setDueAmount(isMakePayment ? dueAmount : roundToDecimalPlaces(totalAmount));
  }
  

  const clickToAddSaleOrder = () => {
    // Validation checks
    if (selectedInvoice.length <= 0) {
        alert('Please select at least one invoice.');
        return;
    }
    if (selectedInvoice.some(data => parseInt(data.rate) === 0)) {
        alert('Price/Unit must be greater than 0.');
        return;
    }
    // if (dueAmount < 0) {
    //     alert('Due amount cannot be less than 0.');
    //     return;
    // }
    if (bankId === 0) {
        alert('Please select payment type like (Cash, Cheque or any bank.)');
        return;
    }
    if (isMakePayment) {
        alert('This delivery challan cannot be edited because a linked payment exists. Please delete the linked transaction to make changes.');
        return;
    }
    if (isChequeMakePayment) {
        alert('This transaction cannot be edited because cheque associated with the transaction is already closed. Re-open the cheque to edit this transaction.');
        return;
    }

    // Prepare selected items
    const selectedItems = selectedInvoice.flatMap(invoice => 
        invoice.items.filter(item => item.isSelect)
    );

    const _selectedInvoice = selectedInvoice.map(invoice => ({
        ...invoice,
        items: selectedItems
    }));

    // Prepare customer and transaction data
    const customer = {
        party_id: partyId,
        party_name: partyName,
        party_contact_no: partyContactNo,
        party_opening_balance: partyRemainBalance,
        billing_name: billingName,
    };

    const prefix = {
        name: prefixName,
        id: prefixId,
        isActive: "1",
    };

    const totalSummary = {
        subtotal: subTotalAmount,
        gstRatio: totalTransTaxRatio,
        gstAmount: totalTransTaxAmount,
        totalDiscount: totalTransDiscountAmount,
        totalQty: totalQuantity,
        totalAmount: totalAmount || 0,
        paidAmount: paidAmount ? parseFloat(paidAmount) : 0,
        dueAmount: dueAmount || 0,
    };

    let _discountPer = (totalTransDiscountAmount / subTotalAmount) * 100;
    _discountPer = roundToDecimalPlaces(_discountPer);

    const transactionWiseAmount = {
        transactionWiseTaxId: transactionWiseTaxId,
        totalTransTaxAmount: totalTransTaxAmount,
        totalTransDiscountPer: _discountPer,
        totalTransDiscountAmount: totalTransDiscountAmount,
    };

    const transactionAdditionalCharge = {
        TransAdditionalCharge1: transAdditionalCharge1,
        TransAdditionalCharge2: transAdditionalCharge2,
        TransAdditionalCharge3: transAdditionalCharge3,
    };

    const transacTransportationDetails = {
        TransportDetailField1: transportDetailField1,
        TransportDetailField2: transportDetailField2,
        TransportDetailField3: transportDetailField3,
        TransportDetailField4: transportDetailField4,
        TransportDetailField5: transportDetailField5,
        TransportDetailField6: transportDetailField6,
    };

    // Create FormData object
    const saleData = new FormData();
    saleData.append("transaction_id", transactionId);
    saleData.append("business_id", businessId);
    saleData.append("user_id", signingId);
    saleData.append("company_id", companyId);
    saleData.append("customer", JSON.stringify(customer));
    saleData.append("billing_address", billingAddress);
    saleData.append("poNumber", poNumber);
    saleData.append("poDate", poDate);
    saleData.append("dueOnDate", dueOnDate);
    saleData.append("dueTerms", termsId);
    saleData.append("E_Way_Bill_No", EWayBillNo);
    saleData.append("prefix", JSON.stringify(prefix));
    saleData.append("invoiceNo", invoiceNo);
    saleData.append("invoiceDate", invoiceDate);
    saleData.append("invoiceNoChallan", invoiceNoChallan);
    saleData.append("invoiceDateChallan", invoiceDateChallan);
    saleData.append("invoiceTime", invoiceTime);
    saleData.append("selectedCountry", countryName);
    saleData.append("countryState", stateName);
    saleData.append("invoiceData", JSON.stringify(_selectedInvoice));
    saleData.append("items", JSON.stringify(selectedItems));
    saleData.append("totalSummary", JSON.stringify(totalSummary));
    saleData.append("transactionWiseAmount", JSON.stringify(transactionWiseAmount));
    saleData.append("transactionAdditionalCharge", JSON.stringify(transactionAdditionalCharge));
    saleData.append("additional_value_1", additionalValue1);
    saleData.append("additional_value_2", additionalValue2);
    saleData.append("additional_value_3", additionalValue3);
    saleData.append("additional_value_date", additionalValue4);
    saleData.append("bankId", bankId);
    saleData.append("bankName", bankName);
    saleData.append("paymentType", paymentType);
    saleData.append("paymentRefNo", paymentRefNo);
    saleData.append("description", description);
    saleData.append("descImage", descImage);
    saleData.append("settingType", printType);
    saleData.append("transactionTransportationDetails", JSON.stringify(transacTransportationDetails));

    if (isEditMode) {
        saleData.append("isMakePayment", isMakePayment);
        saleData.append("totalLinkHistoryAmt", totalLinkHistoryAmt);
    }
    if (isDuplicate) {
        saleData.append("sendUrlType", transactionType);
    }

    const formObject = {};
    saleData.forEach((value, key) => {
      if (key == 'customer' || key == 'prefix' || key == 'invoiceData' || key == 'items' || key == 'totalSummary' || key == 'transactionWiseAmount' || key == 'transactionAdditionalCharge' | key == 'transactionTransportationDetails') {
        value = JSON.parse(value);
      }
      formObject[key] = value;
    });
    console.log('formObject', JSON.stringify(formObject));
    //return;

    
    setIsLoading(true);
    
    // Send the request
    const url = isEditMode ? global.editSaleDeliveryChallanTransaction : global.createSaleDeliveryChallanTransaction;

    fetch(url, {
        method: "POST",
        body: saleData,
    })
    .then(response => response.json())
    .then(res => {
        setIsLoading(false);
        console.error('res:', JSON.stringify(res));
        if (res.success) {
            setTransactionId(res.transaction_Id);
            setShowSuccessDialog(true);
        } else {
            alert(res.message);
        }
        setMessage(res.message);
    })
    .catch(error => {
        console.error('Error:', error);
        setIsLoading(false);
    });
  };

  return (
    <div className="">
      <div className="content">
        <div className="content-header">
          <div className="header-section">
            {/* <h2 className="content-heading">Manage Business</h2> */}
            <h1 className="content-heading">
              <i className="gi gi-direction"></i>Add / Edit Delivery Challan
              <br />
            </h1>
          </div>
        </div>
        <nav className="breadcrumb push">
          <Link className="breadcrumb-item" to={"/business/dashboard/"}>
            Dashboard
          </Link>
          <Link className="breadcrumb-item" to={"/business/manage-sale-delivery-challan/"}>
            Manage Delivery Challan List
          </Link>
          <span className="breadcrumb-item active">
            Add / Edit Delivery Challan List
          </span>
          <Link
            className="breadcrumb-item"
            to={"/business/add-sale-delivery-challan/"}
            target="_blank"
          >
            <i className="fa fa-plus"> (Add More)</i>
          </Link>
        </nav>
        <div className="block">
          <div className="row">
            <div className="col-md-6">
              <div className="block block-transparent">
                <div className="block-content" id="formSideLeft">
                  <div className="form-group row">
                    <div className="col-6">
                      <div
                        className="form-material open"
                        onMouseLeave={() => onMouseLeaveHandler()}
                      >
                        <input
                          disabled={isEditMode || selectedInvoice.length > 0}
                          readOnly={selectedInvoice.length > 0}
                          type="text"
                          className="form-control search-box"
                          onChange={(e) => onChangePartyName(e.target.value)}
                          onClick={() => manageShowPartyFilter()}
                          onBlur={() => partyName && setShowPartyViewList(false)}
                          placeholder="Search Party Name Here..."
                          autoComplete="off"
                          name="party_name"
                          id="party_name"
                          value={partyName ? partyName : searchPartyName}
                        />
                        <label htmlFor="login-username">
                          Party Name <span className="text-danger">*</span>
                        </label>
                        {
                          showPartyViewList &&
                          <ul
                            className={" iti__party-list iti__party-list--dropup"
                            }
                            id="country-listbox"
                            aria-expanded="false"
                            role="listbox"
                            aria-activedescendant="iti-item-ad"
                          >
                            <li
                              key={-1}
                              id="iti-item-in"
                              className="iti__party iti__standard"
                              style={{fontWeight: 'bold'}}
                              onClick={() => {setIsDialogAddNewPArty(true)}}
                            >
                              <span className="iti__party-name">{'Add New Party'}</span>
                            </li>
                            {viewPartyList()}
                          </ul>
                        }
                        <div className={getColorBal() + ' '}>
                          {partyName != ""
                            ? "Bal : " +
                            numberFormat(
                              Math.abs(partyRemainBalance)
                            )
                            : ""}
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-material open">
                        <input
                          type="text"
                          className="form-control search-box"
                          placeholder="Phone Number"
                          autoComplete="off"
                          value={partyContactNo}
                          disabled={isDuplicate}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^[0-9]*$/.test(value)) {
                              setPartyContactNo(value);
                            }
                          }}
                          maxLength="13"
                        />
                        <label htmlFor="login-username">Phone Number</label>

                      </div>
                    </div>
                    {businessSetting.Tran_BillingNameParty == 1 && (
                      <div className="col-6">
                        <div className="form-material open">
                          <input
                            type="text"
                            className="form-control search-box"
                            placeholder="Billing Name Here..."
                            autoComplete="off"
                            value={billingName}
                            disabled={isDuplicate}
                            onChange={(e) => {
                              const value = e.target.value;
                              setBillingName(value);
                            }}
                          />
                          <label htmlFor="login-username">Billing Name</label>
                        </div>
                      </div>
                    )}
                    {businessSetting.Tran_BillingNameParty == 1 && (
                      <div className="col-6">
                        <div className="form-material open">
                          <input
                            type="text"
                            className="form-control search-box"
                            placeholder="Billing Address Here..."
                            autoComplete="off"
                            value={billingAddress}
                            disabled={isDuplicate}
                            onChange={(e) => {
                              const value = e.target.value;
                              setBillingAddress(value);
                            }}
                          />
                          <label htmlFor="login-username">Billing Address</label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="block block-transparent">
                <div className="block-content">
                  <div className="" id="formSideRight">
                    {businessSetting.InvoiceBillNo == 1 && (
                      <div className="form-group row">
                        <label
                          style={{ textAlign: "right" }}
                          className="col-lg-4 col-form-label"
                          htmlFor="val-username"
                        >
                          Challan No. <span className="text-danger">*</span>
                        </label>
                        <div
                          className="col-lg-3 form-material"
                          id="paddingOff"
                        >

                          <select
                            className="form-control "
                            required="required"
                            onChange={(e) => selectPrefix(e)}
                            value={prefixId}
                            disabled={isDuplicate}
                          >

                            {prefixArray.map(
                              (prefixData, index) => {

                                return (
                                  <option
                                    key={index}
                                    value={prefixData.prefix_id}
                                  >
                                    {prefixData.prefix}
                                  </option>
                                );
                              }
                            )}
                          </select>
                        </div>
                        &nbsp;&nbsp;&nbsp;
                        <div
                          className="col-lg-4 form-material"
                          id="paddingOff"
                        >
                          <input
                            type="text"
                            className="form-control"
                            required="required"
                            maxLength="20"
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^[0-9]*$/.test(value)) {
                                setInvoiceNoChallan(value);
                              }
                            }}
                            placeholder="Enter a Invoice No."
                            autoComplete="off"
                            value={invoiceNoChallan}
                          />

                        </div>
                      </div>
                    )}

                    <div className="form-group row">
                      <label
                        style={{ textAlign: "right" }}
                        className="col-lg-4 col-form-label"
                        htmlFor="val-username"
                      >
                        Challan Date <span className="text-danger">*</span>
                      </label>

                      <div className="col-lg-8 form-material" id="paddingOff">
                        {viewInvoiceDate()}
                      </div>
                    </div>
                    {businessSetting.Tran_AddTime == 1 && (
                      <div className="form-group row">
                        <label
                          style={{ textAlign: "right" }}
                          className="col-lg-4 col-form-label"
                          htmlFor="val-username"
                        >
                          Time
                        </label>
                        <div
                          className="col-lg-8 form-material"
                          id="paddingOff"
                          onMouseLeave={() => onMouseLeaveHandlerTime()}
                        >
                          <input
                            readOnly="readOnly"
                            type="text"
                            className="form-control search-box"
                            onClick={() => setIsDialogOpen_Time(true)}
                            placeholder="Please Select Time"
                            autoComplete="off"
                            name="invoiceTime"
                            id="invoiceTime"
                            value={invoiceTime}
                            disabled={isDuplicate}
                          />
                          {
                            isDialogOpen_Time &&
                            <ul
                              className={" iti__party-list iti__party-list--dropup"}
                              id="country-listbox"
                              aria-expanded="false"
                              role="listbox"
                              aria-activedescendant="iti-item-ad"
                            >
                              {getTimeSlotList()}
                            </ul>
                          }
                        </div>
                      </div>
                    )}
                    {businessSetting.SateOfSupply == 1 && (
                      <div className="form-group row">
                        <label
                          style={{ textAlign: "right" }}
                          className="col-lg-4 col-form-label"
                          htmlFor="val-username"
                        >
                          State of Supply
                        </label>
                        <div
                          className="col-lg-8 form-material"
                          id="paddingOff"
                        >
                          <select
                            className="form-control "
                            id="countryState"
                            name="countryState"
                            value={stateName}
                            disabled={isDuplicate}
                            onChange={(e) => setStateName(e.target.value)}
                          >
                            <option value=""> None</option>
                            {stateArray.map((item, index) => {
                              return (
                                <option
                                  key={index}
                                  value={item.name}
                                >
                                  {item.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    )}

                    <div className="form-material open"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* table page */}
          {
            invoiceArray.length > 0 &&
            <QuickTransactionSaleInvoiceSection
                    invoiceArray={invoiceArray}
                    selectedInvoice={selectedInvoice}
                    isEditMode={isEditMode}
                    isMakePayment={isMakePayment}
                    isDuplicate={isDuplicate}
                    transactionType={3}
                    _businessSetting={businessSetting}
                    callBackItem={(selectedInvoice, _totalAmount) => callBack(selectedInvoice, _totalAmount)}
                />
          }
          {/* table page */}
          {
            (invoiceArray.length > 0 && selectedInvoice.length > 0) &&
            <div className="row">
              <div className="col-md-6">
                <div className="block block-transparent">
                  <div className="block-content" id="formSideLeft">
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="form-material open" id="paddingOff">
                          <select
                            className="col-8 form-control"
                            value={bankId}
                            onChange={(e) => selectBank(e)}
                            disabled={isDuplicate}
                          >
                            {
                              bankArray.map((bankD, index) => {
                                return (
                                  <option
                                    key={index}
                                    value={bankD.id}
                                  >
                                    {bankD.bank_name ? bankD.bank_name : bankD.display_name}
                                  </option>
                                )
                              })
                            }
                          </select>
                        </div>
                        {paymentType != "Cash" && (
                          <div className="form-material open">
                            <div
                              className="col-8 form-material"
                              id="paddingOff"
                            >
                              <input
                                type="text"
                                className="form-control"
                                value={paymentRefNo}
                                required="required"
                                onChange={(e) => setPaymentRefNo(e.target.value)}
                                placeholder="Enter Reference No.."
                                autoComplete="off"
                                maxLength={30}
                                disabled={isDuplicate}
                              />
                            </div>
                          </div>
                        )}
                        <div className="form-material open">
                          <div className="col-12 form-material" id="paddingOff">
                            <input
                              type="text"
                              className="form-control"
                              required="required"
                              onChange={(e) => setDescription(e.target.value)}
                              placeholder="Enter a description"
                              autoComplete="off"
                              value={description}
                              disabled={isDuplicate}
                            />
                          </div>
                        </div>
                        <div className="form-material open">
                          <div className="col-10 form-material" id="paddingOff">
                            <input
                              ref={refDescImage}
                              type="file"
                              accept="image/*"
                              style={{ width: "60%", display: "inline-block" }}
                              autoComplete="false"
                              className="form-control"
                              id="descImage"
                              name="descImage"
                                disabled={isDuplicate}
                              onChange={(e) => onChangeFileUploadHandler(e)}
                            />
                            {previewImagesListing()}
                          </div>
                        </div>

                        {businessSetting.PrintOriginalDuplicate == 1 && (
                          <div className="form-material open">
                            <label
                              style={{ textAlign: "right", position: "static" }}
                              className="col-form-label"
                              htmlFor="totalAmount"
                            >
                              Original / Duplicate Setting
                            </label>
                            <div
                              className="col-8 form-material"
                              id="paddingOff"
                            >
                              <select
                                className="col-8 form-control"
                                onChange={(e) => setPrintType(e.target.value)}
                                value={printType}
                                disabled={isDuplicate}
                              >
                                {printTypeList.map(({ value, label }, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={value}
                                    >
                                      {label}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="block block-transparent">
                  <div className="block-content">
                    <div id="taxDisData">
                    <div className="col-md-12" id="formSideRight">
                        <div className="row">
                          <label
                            style={{
                              textAlign: "right",
                            }}
                            className="col-lg-4 col-form-label"
                          >
                            Transaction Discount Amount
                          </label>
                          <div
                            className="col-lg-8 form-material"
                          >
                            <input
                              type="text"
                              className={"form-control"}
                              autoComplete="off"
                              value={totalTransDiscountAmount}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12" id="formSideRight">
                        <div className="row">
                          <label
                            style={{
                              textAlign: "right",
                            }}
                            className="col-lg-4 col-form-label"
                          >
                            Transaction Tax Amount
                          </label>
                          <div
                            className="col-lg-8 form-material"
                          >
                            <input
                              type="text"
                              className={"form-control"}
                              autoComplete="off"
                              value={totalTransTaxAmount}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      
                      
                      {/*Additional Charges */}
                      {businessSetting.TransactionAdditionalChargeEnable ==
                        1 && (
                          <div id="taxDisData">
                            {businessSetting.TransactionAdditionalCharge1Enable ==
                              1 && (
                                <div className="col-md-12" id="formSideRight">
                                  <div className="form-group row">
                                    <label
                                      style={{ textAlign: "right" }}
                                      className="col-lg-4 col-form-label"
                                      htmlFor="TransAdditionalCharge1"
                                    >
                                      {
                                        businessSetting.TransactionAdditionalCharge1Name
                                      }
                                    </label>
                                    <div
                                      className="col-lg-8 form-material"
                                      id="paddingOff"
                                    >
                                      <input
                                        type="text"
                                        className="form-control"
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        onChange={(e) => onChangeAdditionalCharge1(e.target.value)}
                                        placeholder=""
                                        value={transAdditionalCharge1}
                                        autoComplete="off"
                                        disabled={isDuplicate}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}

                            {businessSetting.TransactionAdditionalCharge2Enable ==
                              1 && (
                                <div className="col-md-12" id="formSideRight">
                                  <div className="form-group row">
                                    <label
                                      style={{ textAlign: "right" }}
                                      className="col-lg-4 col-form-label"
                                      htmlFor="TransAdditionalCharge2"
                                    >
                                      {
                                        businessSetting.TransactionAdditionalCharge2Name
                                      }
                                    </label>
                                    <div
                                      className="col-lg-8 form-material"
                                      id="paddingOff"
                                    >
                                      <input
                                        type="text"
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        onChange={(e) => onChangeAdditionalCharge2(e.target.value)}
                                        placeholder=""
                                        className="form-control"
                                        value={transAdditionalCharge2}
                                        autoComplete="off"
                                        style={{
                                          padding: "0 !important",
                                          margin: "0 !important",
                                        }}
                                        disabled={isDuplicate}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}

                            {businessSetting.TransactionAdditionalCharge3Enable ==
                              1 && (
                                <div className="col-md-12" id="formSideRight">
                                  <div className="form-group row">
                                    <label
                                      style={{ textAlign: "right" }}
                                      className="col-lg-4 col-form-label"
                                      htmlFor="TransAdditionalCharge3"
                                    >
                                      {
                                        businessSetting.TransactionAdditionalCharge3Name
                                      }
                                    </label>
                                    <div
                                      className="col-lg-8 form-material"
                                      id="paddingOff"
                                    >
                                      <input
                                        type="text"
                                        className="form-control"
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        onChange={(e) => onChangeAdditionalCharge3(e.target.value)}
                                        placeholder=""
                                        value={transAdditionalCharge3}
                                        autoComplete="off"
                                        disabled={isDuplicate}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                        )}
                      {/*End Additional Charges */}
                    </div>

                    <div className="col-md-12" id="formSideRight">
                      <div className="form-group row">
                        <label
                          style={{ textAlign: "right" }}
                          className="col-lg-4 col-form-label"
                          htmlFor="totalAmount"
                        >
                          Total Amount
                        </label>
                        <div className="col-lg-8 form-material" id="paddingOff">
                          <input
                            type="text"
                            readOnly="readOnly"
                            className="form-control"
                            placeholder=""
                            value={totalAmount}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      
                      <div id="additionFields">
                        {(businessSetting.additional_field_check1 == 1) && (
                          <div className="form-group row">
                            <label
                              style={{ textAlign: "right" }}
                              className="col-lg-4 col-form-label"
                              htmlFor="addF1"
                            >
                              {businessSetting.additional_field_name1}
                            </label>
                            <div
                              className="col-lg-8 form-material"
                              id="paddingOff"
                            >
                              <input
                                type="text"
                                className="form-control"
                                id="additional_value_1"
                                name="additional_value_1"
                                placeholder=""
                                value={additionalValue1}
                                autoComplete="off"
                                disabled={isDuplicate}
                                onChange={(e) => setAdditionalValue1(e.target.value)}
                              />
                            </div>
                          </div>
                        )}

                        {(businessSetting.additional_field_check2 == 1 ||
                          businessSetting.additional_field_check2 ===
                          true) && (
                            <div className="form-group row">
                              <label
                                style={{ textAlign: "right" }}
                                className="col-lg-4 col-form-label"
                                htmlFor="addF2"
                              >
                                {businessSetting.additional_field_name2}
                              </label>
                              <div
                                className="col-lg-8 form-material"
                                id="paddingOff"
                              >
                                <input
                                  type="text"
                                  className="form-control"
                                  id="additional_value_2"
                                  name="additional_value_2"
                                  placeholder=""
                                  value={additionalValue2}
                                  autoComplete="off"
                                disabled={isDuplicate}
                                  onChange={(e) => setAdditionalValue2(e.target.value)}
                                />
                              </div>
                            </div>
                          )}

                        {(businessSetting.additional_field_check3 == 1 ||
                          businessSetting.additional_field_check3 ===
                          true) && (
                            <div className="form-group row">
                              <label
                                style={{ textAlign: "right" }}
                                className="col-lg-4 col-form-label"
                                htmlFor="addF3"
                              >
                                {businessSetting.additional_field_name3}
                              </label>
                              <div
                                className="col-lg-8 form-material"
                                id="paddingOff"
                              >
                                <input
                                  type="text"
                                  className="form-control"
                                  id="additional_value_3"
                                  name="additional_value_3"
                                  placeholder=""
                                  value={additionalValue3}
                                  autoComplete="off"
                                disabled={isDuplicate}
                                  onChange={(e) => setAdditionalValue3(e.target.value)}
                                />
                              </div>
                            </div>
                          )}
                        {(businessSetting.additional_field_date_field_check ===
                          1 ||
                          businessSetting.additional_field_date_field_check ===
                          true) && (
                            <div className="form-group row">
                              <label
                                style={{ textAlign: "right" }}
                                className="col-lg-4 col-form-label"
                                htmlFor="addFDate"
                              >
                                {
                                  businessSetting.additional_field_date_field_name
                                }
                              </label>
                              <div
                                className="col-lg-8 form-material"
                                id="paddingOff"
                              >
                                {viewAdditionalDate()}
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {businessSetting.TransportationDetailsField1Enable == 1 && (
                // Transportation Detail Here
                // <QuickTransportationDetails />
                <div className="block col-md-12">
                  <div className="block block-transparent">
                    <div className="block-content">
                      <h5 className="content-heading">
                        Transportation Details
                      </h5>
                      <div className="block">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="block block-transparent">
                              <div className="block-content" id="formSideLeft">
                                <div className="form-group row">
                                  {businessSetting.TransportationDetailsField1Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField1Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField1"
                                            id="TransportDetailField1"
                                            value={transportDetailField1}
                                            disabled={isDuplicate}
                                            onChange={(e) => setTransportDetailField1(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField1Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {businessSetting.TransportationDetailsField2Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField2Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField2"
                                            id="TransportDetailField2"
                                            value={
                                              transportDetailField2
                                            }
                                            disabled={isDuplicate}
                                            onChange={(e) => setTransportDetailField2(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField2Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {businessSetting.TransportationDetailsField3Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField3Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField3"
                                            id="TransportDetailField3"
                                            value={
                                              transportDetailField3
                                            }
                                            disabled={isDuplicate}
                                            onChange={(e) => setTransportDetailField3(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField3Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {businessSetting.TransportationDetailsField4Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField4Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField4"
                                            id="TransportDetailField4"
                                            value={
                                              transportDetailField4
                                            }
                                            disabled={isDuplicate}
                                            onChange={(e) => setTransportDetailField4(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField4Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {businessSetting.TransportationDetailsField5Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField5Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField5"
                                            id="TransportDetailField5"
                                            value={
                                              transportDetailField5
                                            }
                                            disabled={isDuplicate}
                                            onChange={(e) => setTransportDetailField5(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField5Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {businessSetting.TransportationDetailsField6Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField6Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField6"
                                            id="TransportDetailField6"
                                            value={
                                              transportDetailField6
                                            }
                                            disabled={isDuplicate}
                                            onChange={(e) => setTransportDetailField6(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField6Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="col-md-12">
                <div className="row justify-content-center text-right">
                  <div className="col-lg-9">
                    <button
                      type="submit"
                      onClick={() => clickToAddSaleOrder()}
                      className="btn btn-alt-primary mb-10 mx-5"
                    >
                      Save{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }

        </div>
      </div>
      
      {
        isDialogOpen_AddPrefix && (
          <Dialog width={500} title={'Add New Prefix'} onClose={() => setIsDialogOpen_AddPrefix(false)}>
            <QuickAddNewPrefix
              callBack={(newPrefixId, newPrefixName) => onCallbackAddPrefix(newPrefixId, newPrefixName)}
              transactionType="DELIVERY CHALLAN"
            />

          </Dialog>
        )
      }
      {
          isDialogAddNewParty && (
              <Dialog width={'50%'} height={600}  title={'Add New Party'} onClose={() => setIsDialogAddNewPArty(false)}>
  
                  <QuickAddNewParty isRedirectTo={"business/add-purchase/"} />
  
              </Dialog>
          )
      }
      {
        isDialogAddNewBank && (
            <Dialog  width={'70%'}  title={'Add New Bank'} onClose={() => setIsDialogAddNewBank(false)}>

                <QuickAddNewBankDetail
                  callBack={() => {
                    getBankListData(companyId);
                    setIsDialogAddNewBank(false);
                  }} />

            </Dialog>
        )
      }
      {
        isDialogPreviewImage && (
          <Dialog width={'70%'} height={'70%'} title={'Preview'} onClose={() => setIsDialogPreviewImage(false)}>
              <img
                style={{
                  width: "100%", 
                  height: "100%", 
                  objectFit: "contain"
                }}
                className="preview"
                src={imagePreviewUrl}
                alt={"image-"}
                key="13213"
              />

          </Dialog>
        )
      }

      {
        isLoading && (
          <Dialog >
            <Loader type="converging-spinner" />
          </Dialog>
        )
      }
      {
        showSuccessDialog &&
        <TransactionCreateDialog
        onPreview={() => {
          setShowSuccessDialog(false);
            
          window.location.href = global.webUrl + "business/challanPdfDialog/?new=true&auth=" + transactionId;
        }}
        closeText={isEditMode ? 'Re Edit' : 'Add More'}
        onClose={() => {
          window.location.reload();
        }}
        onBack={() => {
          history.goBack();
        }}
          title={'Success'}
          message={message}
        />
      }

    </div>
  );
}
export default ManageDeliveryChallanCreate